const importers = {
        './src/stories/Introduction.stories.mdx': async () => import('/@fs//opt/build/repo/src/stories/Introduction.stories.mdx'),
  './src/shared/Button/index.stories.tsx': async () => import('/@fs//opt/build/repo/src/shared/Button/index.stories.tsx'),
  './src/shared/Form/index.stories.tsx': async () => import('/@fs//opt/build/repo/src/shared/Form/index.stories.tsx'),
  './src/shared/List/index.stories.tsx': async () => import('/@fs//opt/build/repo/src/shared/List/index.stories.tsx'),
  './src/shared/Modal/index.stories.tsx': async () => import('/@fs//opt/build/repo/src/shared/Modal/index.stories.tsx'),
  './src/stories/Header.stories.tsx': async () => import('/@fs//opt/build/repo/src/stories/Header.stories.tsx'),
  './src/stories/Page.stories.tsx': async () => import('/@fs//opt/build/repo/src/stories/Page.stories.tsx')
    };

    export async function importFn(path) {
        return importers[path]();
    }